import React, { useState } from "react";

export default function App() {
  const [image, setImage] = useState(null);

  const handleCapture = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
    }
  };

  return (
    <div className="app">
      <div className="card">
        <h1>📸 Camera App</h1>
        <p>Click button to capture photo</p>

        <label className="camera-btn">
          Open Camera
          <input
            type="file"
            accept="image/*"
            capture="environment"
            onChange={handleCapture}
            hidden
          />
        </label>

        {image && (
          <div className="preview">
            <img src={image} alt="preview" />
          </div>
        )}
      </div>
    </div>
  );
}
